import React, { useState } from 'react';
import {Icon, Feed, Header, Label} from 'semantic-ui-react'
// import './Card.css';
import Share from './Share'


function CircuitName(props){


    return(
    <Feed size='small' style={{paddingTop: 5}}>
    <Feed.Event style={{paddingLeft: 15}} >

      <Feed.Content style={{marginLeft: 0}}>
        <Feed.Summary>

          <Feed.Label id="title_wrapper">
            {
              <h1 className='title dcgreen'>
                {props.assignment != null ? `${l.assignment}:${props.assignment.name}` : props.title}
              </h1>
            }

          </Feed.Label>

          {action_name!='assignment' && props.circuit && action_name != "lab" &&
              <Feed.Date>{props.circuit.created_at}
              {props.is_public && <Icon name='eye' /> }
              {props.is_public && props.circuit.impressionist_count}
              </Feed.Date>
          }

          {props.assignment &&
          <Feed.Date><p>By {props.assignment.submission_date} </p>
          </Feed.Date>
          }

        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>

      </Feed>
  )
}

export default CircuitName
